import {inject} from "@angular/core";
import {ActiveUserService} from "../services/active-user.service";
import {OidcService} from "../services/oidc.service";
import {Router} from "@angular/router";
import {concatMap, map} from "rxjs";
import {catchError} from "rxjs/operators";
import {GameService} from "../services/game.service";
import {PermissionTypes} from "../enum/PermissionTypes";

export const LandingPageRedirectGuard = () => {
  const activeUserService = inject(ActiveUserService);
  const oidcService = inject(OidcService);
  const gameService = inject(GameService);

  const router = inject(Router);

  const is_authenticated = oidcService.isAuthenticated();
  if (!is_authenticated) {
    return router.navigateByUrl('auth/login');
  }

  const adminId = oidcService.getAdminIdFromClaims();

  if (adminId) {
    return activeUserService.retrieveActiveUser(adminId)
      .pipe(concatMap((adminP) => {
        // Active Draws needs the draw summary; a cross-game admin without it picks a game from the landing page instead.
          if (adminP.CausableAdmin || adminP.CrossGamePermissions?.includes(PermissionTypes.ViewGameSummaryReport)) {

            return gameService.getGamesForUser(adminId).pipe(map(() => {
              return router.navigateByUrl('cross-game-view-draw-landing');
            }));
          }
          // allow any game admins to continue to the landing page
          return gameService.getGamesForUser(adminId).pipe(map(() => true));
       }),
        catchError(() => {
          return router.navigateByUrl('not-admin');
        }))
  } else {
    return router.navigateByUrl('not-admin');
  }

};
